import { type KeyboardEvent, useCallback } from 'react';

/*
 * Do not allow form submission on Enter key press in input fields.
 * Ctrl + Enter or Cmd + Enter should still submit the form.
 */
export function useOnFormEnterKeyDown() {
  const handleFormEnterKeyDown = useCallback((e: KeyboardEvent<HTMLFormElement>) => {
    // https://stackoverflow.com/questions/79247854/how-to-get-an-elements-dom-nodename-from-a-keydown-event
    if (e.target instanceof Node) {
      const nodeName = e.target?.nodeName.toLowerCase();
      if (nodeName === 'input' && e.code.toLowerCase() === 'enter' && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        return false;
      }
    }
  }, []);

  return {
    handleFormEnterKeyDown,
  };
}
